/* eslint-disable no-empty */
import {
  ResponseBaseGetTutorial,
  ResponseBaseGetTutorials,
  ResponseBasePostMarkTutorialAsRead,
} from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const tutorialsApi = createApi({
  reducerPath: 'apiTutorials',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchTutorials: builder.query<
      ResponseBaseGetTutorials,
      {
        hideClub: boolean;
        hideSystem: boolean;
      }
    >({
      query: (request) => ({
        url: '/tutorials',
        method: 'GET',
        params: {
          'hide-club': request.hideClub ? 1 : 0,
          'hide-system': request.hideSystem ? 1 : 0,
        },
      }),
    }),
    fetchTutorial: builder.query<ResponseBaseGetTutorial, number>({
      query: (tutorialId) => ({
        url: `/tutorials/${tutorialId}`,
        method: 'GET',
      }),
    }),
    markTutorialAsRead: builder.mutation<
      ResponseBasePostMarkTutorialAsRead,
      number
    >({
      query: (tutorialId) => ({
        url: `/tutorials/${tutorialId}/mark-as-read`,
        method: 'POST',
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useFetchTutorialsQuery,
  useLazyFetchTutorialsQuery,
  useFetchTutorialQuery,
  useMarkTutorialAsReadMutation,
  reducerPath,
  reducer,
  middleware,
} = tutorialsApi;
